import { render } from "./TextInput.vue?vue&type=template&id=b56b971e&scoped=true"
import script from "./TextInput.vue?vue&type=script&lang=js"
export * from "./TextInput.vue?vue&type=script&lang=js"

import "./TextInput.vue?vue&type=style&index=0&id=b56b971e&scoped=true&lang=css"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b56b971e"],['__file',"resources/js/Shared/TextInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b56b971e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b56b971e', __exports__)) {
    console.log('reload')
    api.reload('b56b971e', __exports__)
  }
  
  module.hot.accept("./TextInput.vue?vue&type=template&id=b56b971e&scoped=true", () => {
    console.log('re-render')
    api.rerender('b56b971e', render)
  })

}


export default __exports__